export const UPDATE_PRESENCE_AND_VALUES_TABLE_PAGE = () => `/update-presence-and-values`;
